import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ENDPOINTS } from "../../../js/api/_config";

/* -----------------------------
   Helper (inside slice)
--------------------------------*/
const formatStatusName = (status) => {
  if (!status) return "";
  const specialCases = {
    Nontextable: "Non-textable",
    Tocall: "To-call",
  };

  if (specialCases[status]) {
    return specialCases[status];
  }
  return status.replace(/([a-z])([A-Z])/g, "$1 $2").trim();
};

/* -----------------------------
   Thunk
--------------------------------*/
export const fetchPatientJourneyById = createAsyncThunk(
  "patientJourney/fetchByPatientId",
  async (patientId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${ENDPOINTS.PATIENT.GET_PATIENT_JOURNEY_BY_PATIENT_ID}?patientID=${patientId}`
      );

      return response.data.data.map((item) => {
        const rawStatus = item.statusName || "";

        return {
          patientTrialJuncID: item.patientTrialJuncID,
          trialName: item.trialName,

          // ✅ normalized for logic
          statusKey: rawStatus.replace(/\s+/g, ""),

          // ✅ formatted for UI
          statusName: item.statusName //formatStatusName(rawStatus),
        };
      });
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);

const initialState = {
  trials: [],
  loading: false,
  error: null,
};

const patientJourneySlice = createSlice({
  name: "patientJourney",
  initialState,

  reducers: {
    resetPatientJourney: (state) => {
      state.trials = [];
      state.loading = false;
      state.error = null;
    },

    /* -----------------------------
       REAL-TIME STATUS UPDATE
    --------------------------------*/
    updateTrialStatusLocal: (state, action) => {
      const { patientTrialJuncID, statusName } = action.payload;

      const trial = state.trials.find(
        (t) => t.patientTrialJuncID === patientTrialJuncID
      );

      if (trial) {
        // trial.statusKey = statusName.replace(/\s+/g, "");
        // trial.statusName = formatStatusName(statusName);
        trial.statusKey = statusName.replace(/\s+/g, "");
        trial.statusName = statusName;
      }
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchPatientJourneyById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPatientJourneyById.fulfilled, (state, action) => {
        state.loading = false;
        state.trials = action.payload;
      })
      .addCase(fetchPatientJourneyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  resetPatientJourney,
  updateTrialStatusLocal,
} = patientJourneySlice.actions;

export default patientJourneySlice.reducer;
